function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var Orbit = (window.WinBoostAiDesignSystem_0f78b0 || {}).Orbit;
var ASSETS = '../../assets/';
var FLAP_CSS = "\n.wb-flap{position:relative;aspect-ratio:3/4;border-radius:20px;overflow:hidden;background:var(--wb-charcoal);perspective:1400px;cursor:pointer}\n.wb-top{position:absolute;top:0;left:0;right:0;height:50%;transform-style:preserve-3d;transition:transform .85s cubic-bezier(.5,.06,.28,1)}\n.wb-flap[data-flipped=\"1\"] .wb-top{transform:rotateX(-180deg)}\n.wb-fc{position:absolute;inset:0;backface-visibility:hidden;overflow:hidden;transition:opacity 0s linear .425s}\n.wb-fc.back{transform:rotateX(180deg);opacity:0}\n.wb-flap[data-flipped=\"1\"] .wb-fc.front{opacity:0}\n.wb-flap[data-flipped=\"1\"] .wb-fc.back{opacity:1}\n.wb-bot{position:absolute;bottom:0;left:0;right:0;height:50%;padding:1.2em 1.4em;display:flex;flex-direction:column;justify-content:flex-start;gap:.4em}\n.wb-seam{position:absolute;left:0;right:0;top:50%;height:1px;background:rgba(255,250,245,.5);z-index:6;pointer-events:none}\n.wb-num{position:absolute;inset:0;display:flex;align-items:center;justify-content:center;font-size:9.4em;font-weight:800;letter-spacing:-.06em;line-height:.8}\n.wb-content{position:absolute;inset:0;padding:1.5em 1.5em;display:flex;flex-direction:column;justify-content:center;gap:.7em}\n.wb-cap{font-size:.9em;line-height:1.2;font-weight:700;letter-spacing:.12em;text-transform:uppercase;color:rgba(255,250,245,.6)}\n.wb-pill{display:flex;align-items:center;gap:.5em;border:1px solid rgba(255,250,245,.16);border-radius:999px;padding:.5em .85em;font-size:.88em;font-weight:700;color:rgba(255,250,245,.66);white-space:nowrap;line-height:1.2}\n.wb-pill.on{border-color:var(--wb-orange);color:var(--wb-cream);background:rgba(252,99,6,.12)}\n.wb-bar{height:1.55em;border-radius:.5em;background:rgba(255,250,245,.08);border:1px solid rgba(255,250,245,.12)}\n@media (prefers-reduced-motion:reduce){.wb-top{transition:none}}\n";
var numFace = function numFace(n, accent) {
  return React.createElement("div", {
    className: "wb-num",
    style: {
      color: accent ? 'var(--wb-orange)' : 'var(--wb-cream)'
    }
  }, n);
};
var graphicFaces = function graphicFaces(base) {
  return [React.createElement("div", {
    className: "wb-content"
  }, React.createElement("div", {
    className: "wb-cap"
  }, "Choisir les agents"), React.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'column',
      gap: '.5em'
    }
  }, React.createElement("div", {
    className: "wb-pill on"
  }, React.createElement("span", {
    style: {
      color: 'var(--wb-orange)'
    }
  }, "\u2713"), "Entrants"), React.createElement("div", {
    className: "wb-pill on"
  }, React.createElement("span", {
    style: {
      color: 'var(--wb-orange)'
    }
  }, "\u2713"), "Sortants"), React.createElement("div", {
    className: "wb-pill on"
  }, React.createElement("span", {
    style: {
      color: 'var(--wb-orange)'
    }
  }, "\u2713"), "SMS IA"))), React.createElement("div", {
    className: "wb-content"
  }, React.createElement("div", {
    className: "wb-cap"
  }, "Moins de 7 minutes"), React.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'column',
      gap: '.5em'
    }
  }, [['Nom de l\u2019entreprise', 'Clinique familiale Riverside'], ['Voix IA', 'Chaleureuse et professionnelle']].map(function (f, i) {
    return React.createElement("div", {
      key: i,
      style: {
        display: 'flex',
        flexDirection: 'column',
        gap: '.18em'
      }
    }, React.createElement("span", {
      style: {
        fontSize: '.86em',
        lineHeight: 1.2,
        fontWeight: 700,
        letterSpacing: '.1em',
        textTransform: 'uppercase',
        color: 'rgba(255,250,245,.5)'
      }
    }, f[0]), React.createElement("div", {
      className: "wb-bar",
      style: {
        height: '1.58em',
        display: 'flex',
        alignItems: 'center',
        padding: '0 .7em',
        fontSize: '.94em',
        lineHeight: 1.2,
        fontWeight: 600,
        color: 'rgba(255,250,245,.85)',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis'
      }
    }, f[1]));
  }), React.createElement("div", {
    className: "wb-pill on",
    style: {
      justifyContent: 'center',
      padding: '.34em .8em',
      fontSize: '.92em',
      lineHeight: 1.2,
      marginTop: '.05em'
    }
  }, "Continuer \u2192"))), React.createElement("div", {
    className: "wb-content"
  }, React.createElement("div", {
    className: "wb-cap"
  }, "Configur\u00e9 en 1 semaine"), React.createElement("div", {
    style: {
      display: 'flex',
      alignItems: 'flex-end',
      gap: '.35em',
      height: '5.2em'
    }
  }, [26, 40, 54, 66, 80, 92, 104].map(function (h, i) {
    return React.createElement("div", {
      key: i,
      style: {
        flex: 1,
        height: h * 0.05 + 'em',
        borderRadius: '.28em',
        background: i > 4 ? 'linear-gradient(0deg,var(--wb-gold),var(--wb-orange))' : 'rgba(255,250,245,.16)'
      }
    });
  })), React.createElement("div", {
    className: "wb-cap",
    style: {
      display: 'flex',
      justifyContent: 'space-between'
    }
  }, React.createElement("span", null, "Jour 1"), React.createElement("span", {
    style: {
      color: 'var(--wb-orange)'
    }
  }, "Jour 7"))), React.createElement("div", {
    className: "wb-content",
    style: {
      alignItems: 'center'
    }
  }, Orbit && React.createElement(Orbit, {
    size: Math.max(48, Math.round(base * 5.4)),
    state: "listening",
    detail: true,
    basePath: ASSETS
  }), React.createElement("div", {
    style: {
      display: 'flex',
      alignItems: 'center',
      gap: '.55em'
    }
  }, React.createElement("span", {
    style: {
      width: '.45em',
      height: '.45em',
      borderRadius: '50%',
      background: '#3ED598'
    }
  }), React.createElement("span", {
    style: {
      fontSize: '.88em',
      fontWeight: 800,
      color: 'var(--wb-cream)',
      letterSpacing: '.02em'
    }
  }, "En service \u00b7 24/7")))];
};
function FlipTile(_ref) {
  var front = _ref.front,
    back = _ref.back,
    flipped = _ref.flipped,
    title = _ref.title,
    desc = _ref.desc,
    base = _ref.base,
    onMeasure = _ref.onMeasure,
    onEnter = _ref.onEnter,
    onLeave = _ref.onLeave,
    onClick = _ref.onClick;
  var box = React.useRef(null);
  React.useEffect(function () {
    var el = box.current;
    if (!el || !onMeasure) return;
    var fit = function fit() {
      return onMeasure(Math.max(8, Math.min(16, el.clientWidth * 0.052)));
    };
    fit();
    var ro = new ResizeObserver(fit);
    ro.observe(el);
    return function () {
      return ro.disconnect();
    };
  }, []);
  return React.createElement("div", {
    ref: box,
    className: "wb-flap",
    style: {
      fontSize: base
    },
    "data-flipped": flipped ? '1' : '0',
    onMouseEnter: onEnter,
    onMouseLeave: onLeave,
    onClick: onClick
  }, React.createElement("div", {
    className: "wb-top"
  }, React.createElement("div", {
    className: "wb-fc front"
  }, front), React.createElement("div", {
    className: "wb-fc back"
  }, back)), React.createElement("div", {
    className: "wb-bot"
  }, React.createElement("h3", {
    style: {
      fontSize: '1.32em',
      fontWeight: 800,
      lineHeight: 1.15,
      minHeight: '2.3em',
      color: 'var(--wb-cream)',
      letterSpacing: '-.01em',
      margin: 0
    }
  }, title), React.createElement("p", {
    style: {
      fontSize: '.94em',
      lineHeight: 1.4,
      color: 'rgba(255,250,245,.62)',
      margin: 0
    }
  }, desc)), React.createElement("div", {
    className: "wb-seam"
  }));
}
function FlipSteps(_ref2) {
  var steps = _ref2.steps;
  var ref = React.useRef(null);
  var _React$useState = React.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    revealed = _React$useState2[0],
    setRevealed = _React$useState2[1];
  var _React$useState3 = React.useState(-1),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    hover = _React$useState4[0],
    setHover = _React$useState4[1];
  var _React$useState5 = React.useState({}),
    _React$useState6 = _slicedToArray(_React$useState5, 2),
    pinned = _React$useState6[0],
    setPinned = _React$useState6[1];
  var _React$useState7 = React.useState(14),
    _React$useState8 = _slicedToArray(_React$useState7, 2),
    base = _React$useState8[0],
    setBase = _React$useState8[1];
  var _React$useState9 = React.useState([0, 0, 0, 0]),
    _React$useState0 = _slicedToArray(_React$useState9, 2),
    step = _React$useState0[0],
    setStep = _React$useState0[1];
  var faces = React.useMemo(function () {
    return graphicFaces(base);
  }, [base]);
  React.useEffect(function () {
    var el = ref.current;
    if (!el) return;
    var io = new IntersectionObserver(function (es) {
      var e = es[es.length - 1];
      if (e.intersectionRatio >= .28) setRevealed(true);else if (e.intersectionRatio === 0) setRevealed(false);
    }, {
      threshold: [0, .28]
    });
    io.observe(el);
    return function () {
      return io.disconnect();
    };
  }, []);
  React.useEffect(function () {
    if (!revealed) {
      setStep([0, 0, 0, 0]);
      setPinned({});
      setHover(-1);
      return;
    }
    var ts = steps.map(function (_, i) {
      return setTimeout(function () {
        return setStep(function (s) {
          var n = s.slice();
          n[i] = 1;
          return n;
        });
      }, i * 260);
    });
    return function () {
      return ts.forEach(clearTimeout);
    };
  }, [revealed]);
  return React.createElement("div", {
    ref: ref
  }, React.createElement("style", null, FLAP_CSS), React.createElement("div", {
    className: "grid",
    style: {
      gridTemplateColumns: 'repeat(4,1fr)',
      gap: 'var(--space-5)'
    }
  }, steps.map(function (_ref3, i) {
    var _ref4 = _slicedToArray(_ref3, 2),
      t = _ref4[0],
      d = _ref4[1];
    var flipped = hover === i !== !!pinned[i] ? !step[i] : !!step[i];
    return React.createElement(FlipTile, {
      key: t,
      title: t,
      desc: d,
      flipped: flipped,
      base: base,
      onMeasure: i === 0 ? setBase : undefined,
      front: numFace('0' + (i + 1), i === 3),
      back: faces[i],
      onEnter: function onEnter() {
        return setHover(i);
      },
      onLeave: function onLeave() {
        return setHover(-1);
      },
      onClick: function onClick() {
        return setPinned(function (p) {
          return _objectSpread(_objectSpread({}, p), {}, _defineProperty({}, i, !p[i]));
        });
      }
    });
  })));
}
Object.assign(window, {
  FlipSteps: FlipSteps,
  FlipTile: FlipTile
});